var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isMainLayout)?_c('span',[_c('MainLayout',[_c('router-view')],1)],1):_c('span',[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }